import { FC } from 'react';
import { MediaCard } from '../MediaCard/MediaCard';
import { type ObjectiveMedia } from '@teachur/http-client';
import { SectionTitle } from '../SectionTitle/SectionTitle';

interface ObjectiveMediaSectionProps {
  media?: ObjectiveMedia[];
  objectiveName?: string;
  objectiveId: number;
}
export const ObjectiveMediaSection: FC<ObjectiveMediaSectionProps> = ({
  media,
  objectiveName,
  objectiveId,
}) => {
  if (!media?.length) return null;
  return (
    <div className="flex flex-col gap-[32px] bg-[var(--neutral-white-NW1000)] rounded-[24px] p-[32px] shadow-[0_4px_30px_0_rgba(0,0,0,0.02)]">
      <SectionTitle>Media</SectionTitle>
      {media.map((mediaItem) => (
        <MediaCard
          key={mediaItem.id}
          media={mediaItem}
          objectiveName={objectiveName}
          objectiveId={objectiveId}
        />
      ))}
    </div>
  );
};
